export const FEATURE_FLAGS = {
  // Stores data for Content Engagement features
  CONTENT_ENGAGEMENT_FEATURE_DATA: 'content_engagement_feature_data',
  WILDFIRE_POC: 'wildfire_poc',
};
